import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Heading,
  Icon,
  Image,
  Input,
  InputGroup,
  InputLeftAddon,
  Switch,
  VStack,
  useDisclosure,
} from '@chakra-ui/react';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';

import UserContext from '../../../context/userContext';
import CustomInput from '../../Common/Input';
import CustomInputSelect from '../../Common/InputSelect';
import AlertWarning from '../../Common/AlertWarning';

import {
  validateEmail,
  validateLastName,
  validatePassword,
  validatePhoneNumber,
  validateName,
  validateOccupation,
  validateClabeInterbancaria,
  validateBankName,
  validateCardName,
} from '../validaciones';

import { obtenerPostventasActivos } from '../../../services/Admin/obtenerPostventasActivos';
import obtenerTitulares from '../../../services/obtenerTitulares';
import crearUsuario from '../../../services/crearUsuario';
import './socios.css';
import { PRECIO_REGEX } from '../../../util/util';
import { useTranslation } from 'react-i18next';

export default function CrearSocio() {
  const { user } = useContext(UserContext);
  const { t } = useTranslation();
  const {
    isOpen: isOpenDialogError,
    onOpen: onOpenDialogError,
    onClose: onCloseDialogError,
  } = useDisclosure();
  const navigate = useNavigate();
  //scroll en errores
  const refPersonales = useRef(null);
  const refSelects = useRef(null);
  const refBancarios = useRef(null);
  const refArchivos = useRef(null);

  const [selectedDateBirth, setSelectedDateBirth] = useState(''); //parte visual
  const [selectedDateContract, setSelectedDateContract] = useState('');

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    nombre: '',
    apellidos: '',
    correo: '',
    numeroTel: '',
    contrasena: '',
    fechaNacimiento: '',
    fechaFirma: '',
    genero: '',
    ocupacion: '',

    coTitular: false,
    idCoTitular: '',

    clabe: '',
    banco: '',
    nombreTarjeta: '',
    membresia: '',
    precioMembresia: '',

    tipoCabana: '',
    postVentaId: '',
    referido: false,
    referidoId: '',
    nochesBaja: "28",
    nochesAlta: "3",
  });

  const [inputErrors, setInputErrors] = useState({
    nombre: '',
    apellidos: '',
    fechaNacimiento: '',
    ocupacion: '',
    correo: '',
    numeroTel: '',
    contrasena: '',
    ocupacion: '',
    fechaFirma: '',

    membresia: '', //select tipo membresía
    precioMembresia: '', //input precio membresía
    idCoTitular: '', //select Titular
    tipoCabana: '', //select tipo cabaña
    postVentaId: '', //select agente
    referidoId: '', //error referido
    genero: '', //select genero

    clabe: '',
    banco: '',
    nombreTarjeta: '',
    membresia: '',

    contratoFirmado: '', //archivos
    avisoPrivacidad: '',
    leyAntilavado: '',

    nochesBaja: '',
    nochesAlta: '',
  });
  const [errorFromServer, setErrorFromServer] = useState({
    error: false,
    msg: '',
  });

  //evitar multiples peticiones http
  const [isCotitular, setIsCotitular] = useState(false);
  const [firstTimeIsCotitular, setFirstTimeIsCotitular] = useState(true);
  const [firstTimeIsReferido, setFirstTimeIsReferido] = useState(true);

  //opciones
  const optionsTipoMembresia = [
    { value: 'false', text: t('HOLDER') },
    { value: 'true', text: t('CO_HOLDER') },
  ];
  const [postVentas, setPostVentas] = useState([
    { value: '', text: t('SELECT_AGENT') },
  ]);
  const [titulares, setTitulares] = useState([
    { value: '', text: t('SELECT_HOLDER_REFERENCE') },
  ]);
  const [referidos, setReferidos] = useState([
    { value: '', text: t('SELECT_HOLDER_REFERENCE') },
  ]);
  const optionsCabana = [
    { value: '', text:  t('SELECT_CABIN')},
    { value: 'BAMBU', text: 'Bambú' },
    { value: 'PIRUL', text: 'Pirul' },
    { value: 'MEZQUITE', text: 'Mezquite' },
  ];
  const optionsGenre = [
    { value: '', text: t('SELECT_GENDER') },
    { value: 'Femenino', text: t('FEMENINE') },
    { value: 'Masculino', text: t('MASCULINE') },
  ];

  //cargar agentes postventas y llenar las opciones al inicio
  useEffect(() => {
    obtenerPostventasActivos(user.id).then((res) => {
      if (res.status === 200) {
        const arr = res.data.postVentas.map((post) => {
          const nombre = post.nombre ? post.nombre : t('NO_NAME');
          const apellidos = post.apellidos ? post.apellidos : t('NO_LAST_NAME');
          const numero = post.numero ? `--Tel:${post.numero}` : t('NO_PHONE');
          return {
            value: post.id,
            text: `${nombre} ${apellidos} ${numero}`,
          };
        });
        setPostVentas([{ value: '', text: t('SELECT_AGENT') }, ...arr]);
      }
    });
  }, []);

  //obtener titulares para opcion de co-titular
  const loadTitulares = () => {
    obtenerTitulares(user.id, 1)
      .then((res) => {
        if (res.status === 200) {
          const arr = res.data.titulares.map((titular) => {
            const nombre = titular.nombre ? titular.nombre : t('NO_NAME');
            const apellidos = titular.apellidos
            const membresia = titular.membresia
              ? titular.membresia
              : t('NO_MEMBERSHIP');

            return {
              value: titular.id,
              text: `${membresia} ${t('NAME')}:${nombre} ${apellidos}`,
              tipoCabana: titular.tipoCabana,
              postVentaId: titular.postVentaId,
            };
          });
          setTitulares([{ value: '', text: t('SELECT_HOLDER_REFERENCE') }, ...arr]);
          setFirstTimeIsCotitular(false);
        }
      })
      .catch((err) => console.log(err));
  };

  //obtener titulares que pueden ser referidos
  const loadReferidos = () => {
    obtenerTitulares(user.id, 0, 1).then((res) => {
      if (res.status === 200) {
        const arr = res.data.titulares.map((titular) => {
          const nombre = titular.nombre ? titular.nombre : t('NO_NAME');
          const membresia = titular.membresia
            ? titular.membresia
            : t('NO_MEMBERSHIP');

          return {
            value: titular.id,
            text: `${membresia} ${t('NAME')}:${nombre}`,
            fechaFirma: titular.fechaFirma,
          };
        });
        setReferidos([
          { value: '', text: t('SELECT_HOLDER_REFERENCE') },
          ...arr,
        ]);
        setFirstTimeIsReferido(false);
      }
    });
  };

  // funcion para obtener datos del titular referido, usado por handleChange
  const getDataTitular = (titulares, idCoTitular) => {
    const arr = titulares.filter((t) => t.value === idCoTitular);
    return arr[0];
  };

  //cambios del formulario
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    //evitar que el back end reciba nulls en tipoCabana y postventaID
    if (name === 'idCoTitular') {
      const titular = getDataTitular(titulares, value);
      setFormData((prevData) => ({
        ...prevData,
        coTitular: true,
        tipoCabana: titular.tipoCabana,
        postVentaId: titular.postVentaId,
        fechaFirma: titular.fechaFirma,
      }));
    }
    if (name === 'referidoId') {
      const titular = referidos.find((t) => t.value === value);
      handleDateChange(e, titular.fechaFirma);
    }
    setInputErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '',
    }));
  };

  //la cambiar tipo de memembresia hay que cambiar unos campos en formdata
  const handleChangeTipoMembresia = (e) => {
    setIsCotitular(e.target.value === 'true');
    setFormData((prevData) => ({
      ...prevData,
      coTitular: e.target.value === 'true',
      referido: false,
    }));
    if (firstTimeIsCotitular || titulares.length < 2) {
      console.log("REQUESTING TITULARES");
      loadTitulares();
    }
  };

  //cambio en input de fecha de nacimiento
  const handleDateChange = (e, fechaFirma = null) => {
    if (!fechaFirma) {
      e.target.name === 'fechaFirma'
        ? setSelectedDateContract(e.target.value)
        : setSelectedDateBirth(e.target.value);
      const fecha = new Date(`${e.target.value}T00:00:00.000Z`);
      fecha.setDate(fecha.getDate());
      setFormData((prevData) => ({
        ...prevData,
        [e.target.name]: fecha,
      }));

      setInputErrors((prevErrors) => ({
        ...prevErrors,
        [e.target.name]: '',
      }));
    } else {
      setSelectedDateContract(fechaFirma.split('T')[0]);
      const fecha = new Date(fechaFirma);
      fecha.setDate(fecha.getDate());
      setFormData((prevData) => ({
        ...prevData,
        fechaFirma: fecha,
      }));
    }
  };

  //validaciones del formularios
  const validateForm = () => {
    const nombreValidation = validateName(formData.nombre);
    const apellidosValidation = validateLastName(formData.apellidos);
    const ocupacionValidation = validateOccupation(formData.ocupacion);
    const correoValidation = validateEmail(formData.correo);
    const numeroTelValidation = validatePhoneNumber(formData.numeroTel);
    const contrasenaValidation = validatePassword(formData.contrasena);

    //datos bancarios
    const bancoValidation = validateBankName(formData.banco);
    const nombreTarjetaValidation = validateCardName(formData.nombreTarjeta);
    const clabeValidation = validateClabeInterbancaria(formData.clabe);
    const membresiaValidation = formData.membresia.trim() === '' ? { error: true, msg: t('BENEFICIARY_NAME') } : false;

    const precioMembresiaValidation = PRECIO_REGEX.test(formData.precioMembresia) ? { error: false, msg: '' } : { error: true, msg: t('INVALID_MEMBERSHIP_PRICE') };

    const errors = {
      nombre: nombreValidation.error ? nombreValidation.msg : '',
      fechaNacimiento: '',
      ocupacion: ocupacionValidation.error ? ocupacionValidation.msg : '',
      apellidos: apellidosValidation.error ? apellidosValidation.msg : '',
      correo: correoValidation.error ? correoValidation.msg : '',
      numeroTel: numeroTelValidation.error ? numeroTelValidation.msg : '',
      contrasena: contrasenaValidation.error ? contrasenaValidation.msg : '',

      idCoTitular:
        isCotitular && formData.idCoTitular === ''
          ? t('REQUIRED_FIELD')
          : '',
      referidoId:
        !isCotitular && formData.referido && formData.referidoId === ''
          ? t('REQUIRED_FIELD')
          : '',
      tipoCabana:
        !isCotitular && formData.tipoCabana === ''
          ? t('REQUIRED_FIELD')
          : '',
      postVentaId:
        !isCotitular && formData.postVentaId === ''
          ? t('REQUIRED_FIELD')
          : '',
      genero: '',
      membresia: membresiaValidation.error ? membresiaValidation.msg : '',
      precioMembresia: precioMembresiaValidation.error ? precioMembresiaValidation.msg : '',
      banco: !isCotitular && bancoValidation.error ? bancoValidation.msg : '',
      nombreTarjeta:
        !isCotitular && nombreTarjetaValidation.error
          ? nombreTarjetaValidation.msg
          : '',
      clabe: !isCotitular && clabeValidation.error ? clabeValidation.msg : '',
      nochesBaja:
        formData.nochesBaja === '' ? t('REQUIRED_FIELD') : formData.nochesBaja < 0 ? t('CANNOT_BE_NEGATIVE') : formData.nochesBaja > 365 ? t('CANNOT_BE_GREATER_THAN_365') : formData.nochesBaja % 7 !== 0 ? t('MUST_BE_MULTIPLE_OF_7') : '',
      nochesAlta:
        formData.nochesAlta === '' ? t('REQUIRED_FIELD') : formData.nochesAlta < 0 ? t('CANNOT_BE_NEGATIVE') : formData.nochesAlta > 3 ? t('CANNOT_BE_GREATER_THAN_3') :'',
    };

    //scroll a la seccion que contiene el error en especifico
    if (
      nombreValidation.error ||
      apellidosValidation.error ||
      correoValidation.error ||
      numeroTelValidation.error ||
      membresiaValidation.error ||
      ocupacionValidation.error ||
      precioMembresiaValidation.error ||
      contrasenaValidation.error
    ) {
      refPersonales.current.scrollIntoView();
    } else if (
      (isCotitular && formData.idCoTitular === '') ||
      (!isCotitular && formData.referido && formData.referidoId === '') ||
      (!isCotitular && formData.tipoCabana === '') ||
      (!isCotitular && formData.postVentaId === '')
    ) {
      refSelects.current.scrollIntoView();
    } else if (
      bancoValidation.error ||
      nombreTarjetaValidation.error ||
      clabeValidation.error
    ) {
      refBancarios.current.scrollIntoView();
    } 
    setInputErrors(errors);
    return Object.values(errors).every((error) => error === '');
  };

  //CAMINOS: ES Cotitular, ES Titular y Referido, o por default ES Tiular y por lo tanto no hay que cambiar nada de formData
  const setDataDifferentsWays = () => {
    //es cotitular
    if (isCotitular) {
      setFormData((prevData) => ({
        ...prevData,
        referido: false,
        referidoId: '',
      }));
      return;
    }
    //es titular y no es referido
    if (!isCotitular && !formData.referido) {
      setFormData((prevData) => ({
        ...prevData,
        isCotitular: false,
        idCoTitular: '',
        referido: false,
        referidoId: '',
      }));
      return;
    }
    return;
  };

  // Función para guardar el socio
  const saveSocio = (e) => {
    e.preventDefault();
    setDataDifferentsWays();
    if (validateForm()) {
      setLoading(true);
      crearUsuario(
        user.id, 
        {
          ...formData, 
          currentDate: new Date().toISOString()
        })
        .then((res) => {
          if (res.status === 200) {
            navigate('/socios');
          } else {
            setErrorFromServer({
              error: true,
              msg: t('ERROR_CREATING_HOLDER'),
            });
            onOpenDialogError();
          }
        })
        .catch((err) => {
          setErrorFromServer({ error: true, msg: err.response.data.error });
          onOpenDialogError();
        }).finally(() => setLoading(false));
    }
  };

  const getInitialLetter = (value) => {
    if (value) {
      return value.charAt(0).toUpperCase();
    }
    return '-';
  }


  return (
    <div className="crearsocio-container">
      <Heading
        ref={refPersonales}
        size={{
          base: 'lg',
          md: 'xl',
          xl: 'xl',
        }}
        style={{ textAlign: 'center' }}
      >
          {t('NEW_MEMBER')}
      </Heading>
      <div className="crearsocio-inputscontainer">

        <VStack
          className="crearsocio-vstack"
          spacing={2}
        >
          <CustomInput
            label={t('FIRST_NAME')}
            type="text"
            name="nombre"
            value={formData.nombre}
            onChange={handleChange}
            error={inputErrors.nombre}
          />
          <CustomInput
            label={t('EMAIL')}
            type="text"
            name="correo"
            value={formData.correo}
            onChange={handleChange}
            error={inputErrors.correo}
          />
          <CustomInputSelect
            label="Tipo de cabaña"
            name="tipoCabana"
            disabled={isCotitular}
            onChange={handleChange}
            value={formData.tipoCabana}
            error={inputErrors.tipoCabana}
            options={optionsCabana}
          />
          {/* <CustomInput
            label="Membresía"
            type="text"
            name="membresia"
            value={formData.membresia}
            onChange={handleChange}
            error={inputErrors.membresia}
          /> */}

          <CustomInput
            label={t('BIRTH_DATE')}
            type="date"
            name="fechaNacimiento"
            value={selectedDateBirth}
            onChange={handleDateChange}
            error={inputErrors.fechaNacimiento}
            max={new Date().toISOString().split('T')[0]}
          />
          <CustomInputSelect
            label={t('GENDER')}
            name="genero"
            disabled={false}
            onChange={handleChange}
            value={formData.genero}
            error={inputErrors.genero}
            options={optionsGenre}
          />
          <CustomInput
            label={t('OCCUPATION')}
            type="text"
            name="ocupacion"
            value={formData.ocupacion}
            onChange={handleChange}
            error={inputErrors.ocupacion}
          />
          <CustomInput
            label={t('PHONE_NUMBER')}
            type="text"
            name="numeroTel"
            value={formData.numeroTel}
            onChange={handleChange}
            error={inputErrors.numeroTel}
          />
          <CustomInput
            label={t('LOW_SEASON_NIGHTS')}
            type="number"
            name="nochesBaja"
            value={formData.nochesBaja}
            error={inputErrors.nochesBaja}
            onChange={handleChange}
          />
        </VStack>

        <VStack
          className="crearsocio-vstack"
          spacing={2}
          ref={refSelects}
        >
          <CustomInput
            label={t('LAST_NAME')}
            type="text"
            name="apellidos"
            value={formData.apellidos}
            onChange={handleChange}
            error={inputErrors.apellidos}
          />

          <CustomInput
            label={t('PASSWORD')}
            type="password"
            name="contrasena"
            value={formData.contrasena}
            onChange={handleChange}
            error={inputErrors.contrasena}
          />
          <div className='container-input'>
            <label id='membresia' style={{fontWeight: 'bold'}}>{t('MEMBERSHIP')}</label>
            <InputGroup>
              <InputLeftAddon>{`LCGC${
                isCotitular ?
                  formData.idCoTitular && titulares ? getInitialLetter(titulares.find(t => t.value === formData.idCoTitular).text) : '-' :
                  formData.tipoCabana ? getInitialLetter(formData.tipoCabana) : '-'}`
              }</InputLeftAddon>
              <Input
                id='membresia'
                className='pxFormContainer'
                type="text"
                name="membresia"
                value={formData.membresia}
                onChange={handleChange}
                error={inputErrors.membresia}
                required
              />
            </InputGroup>
          </div>
          <CustomInputSelect
            label={t('MEMBERSHIP_TYPE')}
            name="tipomembresia"
            disabled={false}
            onChange={handleChangeTipoMembresia}
            value={isCotitular}
            error={inputErrors.membresia}
            options={optionsTipoMembresia}
          />
          <div className='container-input'>
            <label id='precioMembresia' style={{fontWeight: 'bold'}}>{t('MEMBERSHIP_PRICE')}</label>
            <InputGroup>
              <InputLeftAddon>$</InputLeftAddon>
              <Input
                id='precioMembresia'
                className='pxFormContainer'
                type="text"
                name="precioMembresia"
                value={formData.precioMembresia}
                onChange={handleChange}
                required
              />
            </InputGroup>
            {
              inputErrors.precioMembresia && (
                <span className="error-message">{inputErrors.precioMembresia}</span>
              )
            }
          </div>
          <CustomInput
            label={t('CONTRACT_SIGN_DATE')}
            type="date"
            name="fechaFirma"
            value={selectedDateContract}
            onChange={handleDateChange}
            error={inputErrors.fechaFirma}
            max={new Date().toISOString().split('T')[0]}
            disabled={formData.referido}
          />
          <CustomInputSelect
            label={t('POST_SALE_AGENT')}
            name="postVentaId"
            disabled={isCotitular}
            onChange={handleChange}
            value={formData.postVentaId}
            error={inputErrors.postVentaId}
            options={postVentas}
          />

          <CustomInputSelect
            label={t('HOLDER_MEMBERSHIP')}
            name="idCoTitular"
            disabled={!isCotitular}
            onChange={handleChange}
            value={formData.idCoTitular}
            error={inputErrors.idCoTitular}
            options={titulares}
          />
          <CustomInput
            label={t('HIGH_SEASON_NIGHTS')}
            type="number"
            name="nochesAlta"
            value={formData.nochesAlta}
            error={inputErrors.nochesAlta}
            onChange={handleChange}
          />

          <div className="crearsocio-switchcontainer">
            <FormControl
              alignItems="center"
              style={{ display: isCotitular ? 'none' : 'flex' }}
            >
              <FormLabel
                htmlFor="referidoPregunta"
                mb="0"
              >
                <b>{t('WAS_REFERRED')}</b>
              </FormLabel>
              <Switch
                id="referidoPregunta"
                colorScheme="green"
                isChecked={formData.referido}
                onChange={(e) => {
                  setFormData({ ...formData, ['referido']: e.target.checked });
                  if (firstTimeIsReferido || referidos.length < 2) {
                    loadReferidos();
                  }
                }}
                size="md"
                mx="2"
              />
            </FormControl>

            <CustomInputSelect
              label={t('REFERENCE_MEMBER')}
              name="referidoId"
              disabled={!formData.referido}
              onChange={handleChange}
              value={formData.referidoId}
              error={inputErrors.referidoId}
              options={referidos}
            />
          </div>
        </VStack>
      </div>

      <div style={{ width: '100%', display: isCotitular ? 'none' : 'block' }}>
        <hr className="my-4" />
        <Heading
          ref={refBancarios}
          size="lg"
          style={{ textAlign: 'center' }}
        >
          {t('BANK_DETAILS')}
        </Heading>
      </div>
      <div
        className="crearsocio-inputscontainer crearsocio-inputsbank"
        style={{ display: isCotitular ? 'none' : 'flex' }}
      >
        {/* <VStack
          className="crearsocio-vstack"
          spacing={2}
        >
          <CreditCard
            numeroTarjeta={null}
            nombreTarjeta={formData.nombreTarjeta}
          />
        </VStack> */}

        <VStack
          className="crearsocio-vstack"
          spacing={2}
        >
          <CustomInput
            label={t('BANK')}
            type="text"
            name="banco"
            value={formData.banco}
            onChange={handleChange}
            error={inputErrors.banco}
          />
          <CustomInput
            label={t('CLABE')}
            type="text"
            name="clabe"
            value={formData.clabe}
            onChange={handleChange}
            error={inputErrors.clabe}
          />
          <CustomInput
            label={t('BENEFICIARY_NAME')}
            type="text"
            name="nombreTarjeta"
            value={formData.nombreTarjeta}
            onChange={handleChange}
            error={inputErrors.nombreTarjeta}
          />
        </VStack>
      </div>

      <HStack
        spacing={8}
        className="crearsocio-buttonscontainer"
      >
        <Button
          className="crearsocios-button"
          colorScheme="yellow"
          variant="outline"
          onClick={() => navigate('/socios')}
        >
          {t('CANCEL')}
        </Button>
        <Button
          className="crearsocios-button"
          colorScheme="orange"
          variant="solid"
          isLoading={loading}
          loadingText="Guardando..."
          isDisabled={loading}
          mr={3}
          onClick={saveSocio}
        >
            {t('SAVE')}
        </Button>
        <AlertWarning
          header={t('ERROR_CREATING_MEMBER')}
          msg={errorFromServer.msg}
          isOpen={isOpenDialogError}
          onClose={onCloseDialogError}
        />
      </HStack>
    </div>
  );
}
